import { LAST_TIME_OPEN_CASE_ID } from './actionType';

export const initialState = {
    lastTimeOpenCaseId: null,
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case LAST_TIME_OPEN_CASE_ID:
            return {
                ...state,
                lastTimeOpenCaseId: action.payload,
            };
    }
    return state;
};

export default reducer;
